// extracted by mini-css-extract-plugin
module.exports = {"hero":"styles-module--hero--2L5pg","left":"styles-module--left--xdncH","imageLeft":"styles-module--imageLeft--2uyx4","imageRight":"styles-module--imageRight--1FT6b"};